import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PicklistRadioGroup from 'Components/UI/Radio/PicklistRadioGroup';

const styles = (theme) => ({
  root: {
    color: theme.palette.facet.primaryGray,
  },
  label: {
    fontSize: 14,
  },
});

const MeetingHeldStatusPicklist = ({
  className,
  classes,
  onChange,
  value,
  ...rest
}) => {
  return (
    <PicklistRadioGroup
      classes={{
        root: classes.root,
        label: classes.label,
      }}
      color="primary"
      onChange={(v) => {
        return onChange(v);
      }}
      value={value}
      {...rest}
    />
  );
};

MeetingHeldStatusPicklist.defaultProps = {
  className: '',
};

MeetingHeldStatusPicklist.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MeetingHeldStatusPicklist);
